import get from 'lodash/get';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import React, {Component} from 'react';
import { connect } from '~/redux/connect';
import limit from "~/data/limit";
import getConfig from "~/config";
import cancelToken from "~/data/cancelToken";
import {presentAllResultParams, presentAppliedFilterValues, presentResultDependenciesLoaded} from "~/statePresenter";
import {
    getAllResultStateInfos, isDataModelLoaded, isDataModelValid,
} from "~/stateGetter";
import identify from "~/identify";
import { fetchTableResults } from '~/rx/model/tableResults';
import {fetchItem} from "~/rx/model/fetchItem";

export class ResultManager extends Component {
    static propTypes  = {
        // system props
        modelId: PropTypes.string.isRequired,
        children: PropTypes.node,
        requestGroup: PropTypes.string,
        itemRequestGroup: PropTypes.string,

        // filter props
        groupStates: PropTypes.object,
        filters: PropTypes.object,
        filterValues: PropTypes.object.isRequired,
        initialFilterValues: PropTypes.object,

        // result param props
        page: PropTypes.number.isRequired,
        sortOptions: PropTypes.object,
        perPage: PropTypes.number.isRequired,

        // callbacks
        resultActions: PropTypes.object,
        invalidateResults: PropTypes.func
    };

    static defaultProps = {
        children: null
    };

    getResultRequestGroup() {
        if(this.props.requestGroup) { return this.props.requestGroup; }
        return identify.modelResultsRequestGroup(this.props.modelId);
    }

    getCancelToken = () => cancelToken(this.getResultRequestGroup());

    updateResults = () => {
        limit(this.getResultRequestGroup(), () => {
            this.props.fetchTableResults(this.getCancelToken());
        });
    };

    sync() {
        let { loadedResultParams, loadingResultParams, resultParams, resultState } = this.props;

        if(resultState.status === identify.STATUS_ERRORED) {
            return false;
        }

        if(!this.props.isDataModelLoaded) {
            return false;
        }

        if(!this.props.resultDependenciesLoaded) {
            return false;
        }

        let areLoadedResultParamsEqual = isEqual(resultParams, loadedResultParams);

        if(this.props.resultState.status === identify.STATUS_INVALIDATED) {
            this.updateResults();
            return true;
        }

        let shouldSync = !isEqual(resultParams, loadingResultParams) &&
            !areLoadedResultParamsEqual;

        if(shouldSync) {
            this.updateResults();
        } else if(areLoadedResultParamsEqual) {
            this.getCancelToken().cancel();
        }
    }

    componentDidMount() {
        this.sync();
    }

    componentDidUpdate(prevProps) {
        this.sync(prevProps);
    }

    render() {
        return this.props.children;
    }
}

const ModelResultManager = connect((state, { modelId }) => {
    let isTheDataModelLoaded = true;
    if(!isTheDataModelLoaded) {
        return { isDataModelLoaded: isTheDataModelLoaded };
    }

    return {
        isDataModelLoaded: isTheDataModelLoaded,
        ...getAllResultStateInfos(state, modelId)
    };

}, (dispatch, { modelId }) => {
    return {
        fetchTableResults: (cancelToken) => dispatch(fetchTableResults(modelId, cancelToken)),
        fetchItem: (id, cancelToken) => dispatch(fetchItem(id, null, cancelToken))
    }
}, (stateProps, dispatchProps, ownProps) => {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        resultDependenciesLoaded: presentResultDependenciesLoaded(stateProps),
        resultParams: presentAllResultParams(stateProps)
    }
})(ResultManager);

export default ModelResultManager;